





























import { ROUTES } from "@/constants/routes";
import Vue from "vue";
import UserAppList from "@/components/UserAppList.vue";
import urls from "@/constants/urls";
import { App } from "@/model/App";
import LoadingDestore from "@/components/LoadingDestore.vue";

export default Vue.extend({
  name: "ProfilePage",
  components: { UserAppList, LoadingDestore },
  data(): {
    webId: string;
    profileImg: string;
    apps: App[];
    isLoading: boolean;
  } {
    return {
      webId: "",
      profileImg: "",
      apps: [],
      isLoading: true,
    };
  },
  methods: {
    confirmLogout() {
      this.$buefy.dialog.confirm({
        title: "Warning for Soliders",
        message:
          "Logging out of DeStore <b>will not</b> log you out of your SOLID account, so next time you will be logged into DeStore automatically." +
          "<br/><br/> If you want to logout completely, go to your SOLID profile and logout from there.",
        confirmText: "Logout",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch("logout");
          this.$router.push(ROUTES.HOME.path).catch();
        },
      });
    },
  },
  created() {
    const sessionId = this.$store.getters.getSessionId;
    const URL = urls.url_to_profile + sessionId;
    console.log(URL)
    const options = {
      method: "GET", // or 'PUT'
    };
    fetch(URL, options)
      .then((response) => {
        if (response.status === 401) {
          this.$router.push(ROUTES.SESSION_EXPIRED.path);
          return;
        }
        if (!response.ok) {
          throw Error();
        }
        return response.json();
      })
      .then((data: any) => {
        console.log(data);
        this.webId = data.webId;
        const regex = /https:\/\/(.*).inrupt/;
        const results = this.webId.match(regex);
        if (results && results.length > 0) {
          this.webId = results[1];
        } else {
          this.webId = "Unknown";
        }
        this.profileImg = data.profileImage;
        this.apps = data.apps as App[];
        this.isLoading = false;
      });
  },
});
